/**
 * Wire-exact interfaces for the Phase 18d admin apps surface
 * (backend: registerAppRoutes in apps/backend/src/routes/admin.ts).
 */

/** GET /api/admin/app-hosts — one row per host, with live probe/counts/disk. */
export interface AdminAppHost {
  id: number;
  name: string;
  pve_vmid: number | null;
  ssh_host: string;
  ssh_port: number;
  ssh_user: string;
  ssh_key_path: string;
  capacity_mem_mb: number;
  enabled: boolean;
  created_at: string;
  probe: { reachable: boolean };
  /** live running-or-creating instance count */
  instances: number;
  instances_total: number;
  /** fresh sweep disk reading, null when the sweep cache is cold/stale */
  disk: { free_mb: number; at: string } | null;
}

/** GET /api/admin/app-instances — all non-deleted instances, cross-customer. */
export interface AdminAppInstance {
  id: number;
  customer_id: number;
  username: string;
  name: string;
  template_slug: string;
  status: string;
  subdomain: string | null;
  host_id: number;
  host: string | null;
  template_commit: string | null;
  resources_mem_mb: number | null;
  created_at: string;
  updated_at: string;
}

/** GET /api/admin/app-hosts/:id/orphans */
export interface AdminOrphansResponse {
  orphans: { project: string; detected_at: string }[];
}

/** Matches the backend APPS_DOMAIN — subdomain rows store the label part. */
export const APPS_DOMAIN = "apps.noctools.nz";
